<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="copyt">Published in the United States of America and</p>
<p class="copy">Great Britain in 2020 by</p>
<p class="copy">CASEMATE PUBLISHERS</p>
<p class="copy">1950 Lawrence Road, Havertown, PA 19083, USA</p>
<p class="copy">The Old Music Hall, 106–108 Cowley Road, Oxford OX4 1JE, UK</p>
<p class="copy1">© Casemate Publishers 2020</p>
<p class="copy1">Hardback Edition: ISBN 978-1-61200-771-7</p>
<p class="copy">Digital Edition: ISBN 978-1-61200-772-4</p>
<p class="copy">Kindle Edition: ISBN 978-1-61200-772-4</p>
<p class="copy1">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the publisher in writing.</p>
<p class="copy1">A CIP record for this book is available from the British Library</p>
<p class="copy"><span class="weblink"><a href="http://www.casematepublishingservices.com" target="_blank"><span class="underline">www.casematepublishingservices.com</span></a></span></p>
<p class="copy1">For a complete list of Casemate titles, please contact:</p>
<p class="copy1">CASEMATE PUBLISHERS (US)</p>
<p class="copy">Telephone (610) 853-9131</p>
<p class="copy">Fax (610) 853-9146</p>
<p class="copy">Email: <span class="weblink"><a href="mailto:casemate@casematepublishers.com"><span class="underline">casemate@casematepublishers.com</span></a></span></p>
<p class="copy"><span class="weblink"><a href="http://www.casematepublishers.com" target="_blank"><span class="underline">www.casematepublishers.com</span></a></span></p>
<p class="copy1">CASEMATE PUBLISHERS (UK)</p>
<p class="copy">Telephone (01865) 241249</p>
<p class="copy">Email: <span class="weblink"><a href="mailto:casemate-uk@casematepublishers.co.uk"><span class="underline">casemate-uk@casematepublishers.co.uk</span></a></span></p>
<p class="copy"><span class="weblink"><a href="http://www.casematepublishers.co.uk" target="_blank"><span class="underline">www.casematepublishers.co.uk</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Copyright.vue?8f0c316e